import React, { useState, Fragment, useEffect } from 'react'
import Modal from '../Modal'
import * as Icon from 'react-feather'
import Button from '../Button';
import { Switch } from '@headlessui/react'
import { Popover, Transition } from '@headlessui/react';
import { useGet } from "../../libs/service/api";
import cookie from "../../libs/cookie/client";
const MembersModal = props => {
    const [enabled, setEnabled] = useState(props.isVisible)
    const [shareTeamData, setShareTeamData] = useState([])
    const [needsAssesmentID, setNeedsAssesmentID] = useState(cookie.getItem("needsassesmentid"))
    const OnGetData = (id) => {
        useGet('/commonapi/shares?NeedsAssesmentID=' + id)
            .then(res => {
                if (!res.ErrorState) {
                    console.log(res.Data.Table)
                    setShareTeamData(res.Data.Table)
                }

            });
    }

    const closeTrigger = (e) => {
        props.onCloseTrigger()
    }

    useEffect(() => {
        setEnabled(props.isVisible)
        setNeedsAssesmentID(cookie.getItem("needsassesmentid"))
        OnGetData(cookie.getItem("needsassesmentid"))
    }, [props.isVisible])

    return (
        <Modal isOpen={false} closeTrigger={() => { closeTrigger() }} size="small">
            
            <div className="flex justify-between text-primary font-semibold" >
                <h4>Members (1)</h4>
                <button className="font-semibold" onClick={() => {
                    setEnabled(false)
                    props.onCloseTrigger()
                }}>Close</button>
            </div>
            <div className="text-vp-lightbrown flex items-center py-4 border-b border-vp-lightbrown"><Icon.HelpCircle className="w-4 mr-2" /> Learn about adding members to your dashboard</div>
            <div className="flex items-center my-4">
                <div className="font-semibold mr-4">Invite Link</div>
                <Switch
                    checked={enabled}
                    onChange={setEnabled}
                    className={`${enabled ? 'bg-primary-light border-primary' : 'bg-vp-lightgray border-vp-lightbrown'}
                relative inline-flex flex-shrink-0 w-10 h-5 border-2  rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75`}
                >
                    <span className="sr-only">Use setting</span>
                    <span
                        aria-hidden="true"
                        className={`${enabled ? 'translate-x-5 bg-primary' : 'translate-x-0 bg-vp-lightbrown'}
                    pointer-events-none inline-block h-4 w-4 rounded-full  shadow-lg transform ring-0 transition ease-in-out duration-200`}
                    />
                </Switch>
            </div>
            <div className="text-sm">
                Share this secret link to invite people to this workspace. Only admins can see this. You can reset the link to generate a new invite link.
            </div>
            <div className="rounded-lg bg-primary-light flex items-center justify-center px-x py-5 my-4 text-primary">
                www.viewprogis.com
            </div>
            <div className="pb-4 mb-4 border-b border-vp-lightbrown">
                <Button btnStyle="primary" text="Copy link" />
            </div>
            <div>
                <h4 className="font-semibold mb-4">Members</h4>
                <div className="text-sm">Manage members here</div>
                <div className="py-4">
                    <Button btnStyle="primary" text="Add members" onClick={props.onAddMemberClick} />
                </div>
            </div>
            <div className="pb-4">
                <div className="flex py-2.5 border-t border-b text-vp-brown border-vp-lightbrown justify-between">
                    <div>User</div>
                    <div>Access level</div>
                </div>
                {shareTeamData && shareTeamData.length > 0 && shareTeamData.map((item, index) => {
                    return <div className="flex justify-between py-2.5 border-b border-vp-lightbrown">

                        <div>
                            <h3 className="text-sm font-bold">{item.Name}</h3>
                            <div className="text-xs">{item.EmailID}</div>
                        </div>
                        <div>
                            <Popover className="relative">
                                {({ open }) => (
                                    <>
                                        <Popover.Button
                                            className={`
                ${open ? '' : 'text-opacity-90'}
                text-black group bg-orange-700 px-3 py-2 rounded-md inline-flex items-center text-base font-medium hover:text-opacity-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75`}
                                        >
                                            <span>{item.RightsLevel}</span>
                                            <Icon.ChevronDown />
                                        </Popover.Button>
                                        <Transition
                                            as={Fragment}
                                            enter="transition ease-out duration-200"
                                            enterFrom="opacity-0 translate-y-1"
                                            enterTo="opacity-100 translate-y-0"
                                            leave="transition ease-in duration-150"
                                            leaveFrom="opacity-100 translate-y-0"
                                            leaveTo="opacity-0 translate-y-1"
                                        >
                                            <Popover.Panel className="absolute z-10 bottom-0 w-64 max-w-sm px-4 transform left-full sm:px-0 lg:max-w-3xl">
                                                <div className="rounded-md border-primary border bg-white  overflow-hidden">
                                                    <div className="group p-2 hover:bg-primary-light cursor-pointer">
                                                        <div className="font-semibold group-hover:text-primary">Admin</div>
                                                        <div className="text-sm">Can change dashboard settinngs and invite new members.</div>
                                                    </div>
                                                    <div className="group p-2 hover:bg-primary-light cursor-pointer">
                                                        <div className="font-semibold group-hover:text-primary">Member</div>
                                                        <div className="text-sm">Cannot change settings but can preview dashboard.</div>
                                                    </div>
                                                    <div className="group p-2 hover:bg-primary-light cursor-pointer">
                                                        <div className="font-semibold text-secondary">Leave Team</div>
                                                    </div>
                                                </div>
                                            </Popover.Panel>
                                        </Transition>
                                    </>
                                )}
                            </Popover>
                        </div>
                    </div>
                })
                }
            </div>
        </Modal>
    )
}


export default MembersModal
